import React, { useContext, useState } from 'react'
import { socket } from '../socket';
import { GVarState } from '../StoreState/Gstate';
import "./NextPre.css"
import { localSocket } from '../gopro/Connect';
function NextPre() {
    let g = useContext(GVarState);

    function killpath(data) {
        if (data === "kill") {
            g.setpath([])
            g.setStapeByStape(null);
            g.setNextPrev(null);
            g.setStartAndEndPart(false)
            g.setselectPointA(undefined)
            g.setselectPointB(undefined)
            g.setSelectShapData(null)
            g.setEndSearchInput(null)
            g.setStartSearchInput(null)
            g.setActiveFloor(0)
        }
    }
    function nextandpre(data) {
        console.log("isme data", data);
        if (data === "next") {
            g.setCurrentFloor(g.NextPrev[g.ActiveFloor + 1])
            g.setActiveFloor(g.ActiveFloor + 1)
        }
        if (data === "pre") {
            g.setCurrentFloor(g.NextPrev[g.ActiveFloor - 1])
            g.setActiveFloor(g.ActiveFloor - 1)
        }
    }
    // [].indexOf
    // console.log(g.NextPrev);
    return (
        <div className='NextPre'>
            {g.ActiveFloor == 0 ?
                <button className='prev' style={{ color: "#e52070", border: "1px solid #e52070", backgroundColor: "white" }}>Previous Step</button>
                : <button className='prev preBg' onClick={() => {
                    // g.setCurrentFloor(g.NextPrev[g.ActiveFloor - 1])
                    if (navigator.onLine) {
                        if (socket.connected) {
                            let ildId = localStorage.getItem("ids")
                            if (socket.id == ildId) {
                                socket.emit("nextandpre", { id: socket.id, data: "pre" })
                                console.log(socket.connected, "logging in");
                            } else {
                                console.log(socket.connected, "logging out");
                                localSocket("nextandpre", { data: "pre" }, nextandpre)
                            }
                        }

                    } else {
                        localSocket("nextandpre", { data: "pre" }, nextandpre)
                    }
                    // g.setActiveFloor(g.ActiveFloor - 1)

                }}>Previous Step</button>
            }
            {g.NextPrev.length - 1 === g.ActiveFloor ?
                <button className='end endBg' onClick={() => {
                    socket.emit("killpath", { id: socket.id })
                    localSocket("killpath", { id: socket.id }, killpath)
                    // g.setStartAndEndPart(false)
                    // g.setEndSearchInput(null)
                    // g.setStartSearchInput(null)
                    // g.setStapeByStape(null)
                    // g.setpath([])

                }}>End Trip</button> :
                <button className='next nextBg' onClick={() => {
                    // g.setCurrentFloor(g.NextPrev[g.ActiveFloor + 1])
                    // g.setActiveFloor(g.ActiveFloor + 1)
                    if (navigator.onLine) {
                        if (socket.connected) {
                            let ildId = localStorage.getItem("ids")
                            if (socket.id == ildId) {
                                socket.emit("nextandpre", { id: socket.id, data: "next" })
                                console.log(socket.connected, "logging in");
                            } else {
                                console.log(socket.connected, "logging out");
                                localSocket("nextandpre", { data: "next" }, nextandpre)
                            }
                        }
                    } else {

                        localSocket("nextandpre", { data: "next" }, nextandpre)
                    }
                }}>Next Step</button>
            }
        </div>
    )
}

export default NextPre